import PropTypes from 'prop-types';
import RoundButton from '../../components/round-button/RoundButton';
import { mailShareUrl } from '../../utils';
import styles from './shareInProject.module.less';
import { Icon } from '@sb1/ffe-icons-react';
import mail from '@sb1/ffe-icons/icons/open/300/lg/mail.svg';

const MailShareButton = function ({
    urlToShare,
    mailSubject,
    trackEventName,
    trackEventFunction,
    buttonClassName,
    containerClassName,
}) {
    const mailUrl = mailShareUrl(urlToShare, mailSubject);

    return (
        <div className={[styles.shareComponent, containerClassName].join(' ')}>
            <RoundButton
                onClick={() => {
                    trackEventFunction();
                    location.href = mailUrl;
                }}
                className={buttonClassName}
                category={trackEventName}
                action="mail"
                alt="Del på mail"
                label={urlToShare}
            >
                <Icon fileUrl={mail} size="lg" />
            </RoundButton>
            <div className={styles.shareDescription}>E-post</div>
        </div>
    );
};

MailShareButton.defaultProps = {
    trackEventName: 'share',
    buttonClassName: '',
};

MailShareButton.propTypes = {
    urlToShare: PropTypes.string.isRequired,
    mailSubject: PropTypes.string.isRequired,
    trackEventName: PropTypes.string,
    buttonClassName: PropTypes.string,
    trackEventFunction: PropTypes.func,
};

export default MailShareButton;
